import React from "react";
import Link from "next/link";

export default function RecentNews({ data }) {
  const { advanceData } = data;

  const rawNewsItems = advanceData?.data;
  const newsItems = (Array.isArray(rawNewsItems) ? rawNewsItems : []).map((item) => ({
    id: item.id,
    image: item.featureImg || "https://html.merku.love/shelly/assets/img/default.jpg",
    language: "English",
    date: item?.publishedAt
      ? new Date(item.publishedAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "",
    author: item.createdBy
      ? `${item.createdBy.firstName} ${item.createdBy.lastName}`
      : "Unknown",
    categories: item.tags || [],
    title: item.title,
    description: item.description.replace(/<[^>]+>/g, "").slice(0, 150) + "...",
    uri: item.uri,
  }));

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="mb-4 text-center text-5xl font-bold text-gray-800">
        {data?.heading}
      </h2>

      <p className="mx-auto mb-12 max-w-3xl text-center text-gray-600">
        {data?.subHeading}
      </p>

      <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {newsItems.map((item) => (
          <div key={item.id} className="overflow-hidden rounded-lg bg-white shadow-md">
            <div className="relative">
              <div className="aspect-video w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  width={640}
                  height={360}
                  className="h-full w-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </div>

              <div className="absolute bottom-4 left-4">
                <span className="rounded-full bg-yellow-400 px-4 py-1 text-sm font-semibold text-black">
                  {item.language}
                </span>
              </div>
            </div>

            <div className="p-6">
              <div className="mb-2 flex items-center text-sm text-gray-500">
                <span>{item.date}</span>
              </div>

              <h3 className="mb-2 line-clamp-3 text-2xl font-bold text-gray-800">
                {item.title}
              </h3>

              <p className="mb-4 line-clamp-4 text-gray-600">{item.description}</p>

              <Link
                href={`blog/${item.uri}`}
                className="flex items-center font-medium text-blue-600"
              >
                Read
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="ml-1 h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
